// src/api/eventService.js

import axios from 'axios';

// Utiliser l'URL de l'API depuis les variables d'environnement
const apiUrl = process.env.REACT_APP_API_URL || 'https://admin.propentatech.com/api/';

// Instance axios pour les requêtes API
const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Service pour les événements
const eventService = {
  // Récupérer tous les événements
  getAll: (params = {}) => api.get('/events/', { params }),
  
  // Récupérer un événement par son identifiant ou son slug
  getById: (idOrSlug) => api.get(`/events/${idOrSlug}/`),
  
  // Inscription à un événement
  register: (id, data) => {
    // S'assurer que l'ID de l'événement est inclus dans les données
    const registrationData = {
      ...data,
      event: id
    };
    
    console.log("Registration data being sent:", registrationData);
    return api.post('/event-registrations/', registrationData);
  },
  
  // Annuler une inscription
  unregister: (id, email) => api.post(`/events/${id}/unregister/`, { email }),
  
  // Système de likes (anonyme)
  like: (id, anonymousId) => api.post(`/events/${id}/like/`, { anonymous_id: anonymousId }),
  
  // Enlever un like
  unlike: (id, anonymousId) => api.delete(`/events/${id}/like/`, { 
    data: { anonymous_id: anonymousId } 
  }),
  
  // Récupérer les événements à venir
  getUpcoming: () => api.get('/events/upcoming/'),
  
  // Récupérer les événements par type
  getByType: (eventType) => api.get('/events/', { params: { event_type: eventType } }),
  
  // Recherche d'événements
  search: (query) => api.get('/events/search/', { params: { q: query } }),
};

export default eventService;